import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts/Layout";
import { firestore, collection, getDocs, query, orderBy } from "../firebase-config";
import "../styles/Blog.css";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [categories, setCategories] = useState([]);

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsQuery = query(collection(firestore, 'posts'), orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(postsQuery);
        const fetchedPosts = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setPosts(fetchedPosts);
        setFilteredPosts(fetchedPosts);
        
        // Extract unique categories
        const uniqueCategories = [...new Set(fetchedPosts.map(post => post.category).filter(Boolean))];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  useEffect(() => {
    if (selectedCategory === 'all') {
      setFilteredPosts(posts);
    } else {
      setFilteredPosts(posts.filter(post => post.category === selectedCategory));
    }
  }, [selectedCategory, posts]);

  if (loading) {
    return (
      <Layout featureType="blog">
        <h2>Church Blog</h2>
        <p>Loading posts...</p>
      </Layout>
    );
  }

  return (
    <Layout featureType="blog">
      <h2>Church Blog</h2>
      <p>
        Here you can find recent blog posts, articles, and updates from Crich Baptist Church.
      </p>

      {categories.length > 0 && (
        <div className="blog-filters">
          <label htmlFor="category-filter">Filter by category:</label>
          <select 
            id="category-filter"
            value={selectedCategory} 
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
      )}

      {filteredPosts.length > 0 ? (
        filteredPosts.map(post => (
          <div key={post.id} className="blog-post-preview">
            <h3>
              <Link to={`/blog/${post.id}`}>{post.title}</Link>
            </h3>
            <p className="post-meta">
              {post.category && <span className="category-badge">{post.category}</span>}
              <span>Published: {formatDate(post.createdAt)}</span>
            </p>
          </div>
        ))
      ) : (
        <p>No blog posts available{selectedCategory !== 'all' ? ' in this category' : ''  }.</p>
      )}
    </Layout>
  );
};

export default Blog;